.SignaturePad {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  cursor: crosshair;
}

.SignaturePadPlaceholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  & > p {
    color: rgb(224 224 224 / var(--tw-text-opacity, 1));
    font-weight: 500;
    font-size: 1.875rem;
    line-height: 2.25rem;

    & > img {
      width: 1.75rem;
      height: 2.5rem;
      margin-right: 0.375rem;
    }
  }
}

.SignaturePadButtons {
  position: absolute;
  top: 0;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  & > div {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    padding: 0.5rem;
    width: fit-content;
    cursor: pointer;

    & > p {
      font-size: 0.75rem;
      font-weight: 500;
      user-select: none;
      margin: 0;
    }

    & > img {
      width: 0.875rem;
      height: 0.875rem;
    }
  }
}

.ClearButton {
  background-color: rgb(250 220 220 / var(--tw-bg-opacity, 1));
  color: rgb(204 102 102 / var(--tw-text-opacity, 1));
  border-bottom-right-radius: 1rem;
}

.DownloadButton {
  background-color: rgb(220 235 250 / var(--tw-bg-opacity, 1));
  color: rgb(102 153 204 / var(--tw-text-opacity, 1));
  border-bottom-left-radius: 1rem;
}
